exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".igx-icon{display:flex;position:relative;font-size:1.5em;justify-content:center}.igx-icon--inactive{color:rgba(0,0,0,.38)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true}!./node_modules/sass-loader/lib/loader.js!./src/icon/icon.component.scss
// module id = 56
// module chunks = 0 1